import { StorageKeys } from '#/service/constants';

// Only add very specific ignores, and only for messages that we NEVER care about.
const ignores = [
  'Each child in a list should have a unique "key" prop.',
  'Warning: Encountered two children with the same key,',
  'Can\'t convert literal value "NONE" to type of "null" (object)',
  'Can\'t convert literal value "GENERIC" to type of "null" (object)',
  'VIDEOJS: WARN: videojs.bind is deprecated and will be removed in 9.0',
  'VIDEOJS: WARN: videojs.mergeOptions is deprecated and will be removed in 9.0',
  'It is recommended that a robustness level be specified. Not specifying the',
];

const levels = ['warn', 'error'];

export const consoleIgnores: any[] = [];

export const overrideConsole = () => {
  const isLocal = process.env.goal === 'local';
  const isEnabled =
    localStorage.getItem(StorageKeys.DEVTOOLS_CONSOLE_OVERRIDE) === 'true';

  if (!isLocal || !isEnabled) {
    return;
  }

  levels.forEach((level) => {
    // remember original method
    const original = console[level];

    // create a replacement method, conditionally calling the original
    const override = (...args: any[]) => {
      if (ignores.some((ignore) => args[0]?.includes?.(ignore))) {
        consoleIgnores.push([level.toUpperCase(), ...args]);

        return;
      }

      original(...args);
    };

    // put a helpful name on it to clarify stack traces
    Object.defineProperty(override, 'name', {
      value: `console.${level} override`,
    });

    console[level] = override;
  });

  console.debug('Local console overrides applied.');
};
